<template lang="pug">
  a.recipe-category-link(
    :href="relativeLink"
    :data-vars-link-href="$isAMP ? analyticsLink : undefined"
    @click="onClick"
    target="_blank"
  ) {{text}}
</template>

<script lang="ts">
  import type { PropType } from 'vue';

  import { getFullUrl } from '~/utils';
  import { removeLifehackerFromUrl } from '~/utils/removeLifehackerFromUrl';

  export default defineNuxtComponent({
    name: 'RecipeCategoryLink',

    props: {
      link: {
        type: String as PropType<string>,
        required: true,
      },
      text: {
        type: String as PropType<string>,
        required: true,
      },
    },

    computed: {
      analyticsLink(): string {
        return getFullUrl(this.link);
      },

      relativeLink(): string {
        return removeLifehackerFromUrl(this.link);
      },
    },

    methods: {
      onClick(): void {
        this.$emit('click-by-category');
      },
    },
  });
</script>

<style lang="scss" scoped>
  .recipe-category-link {
    @include fontSmallTextBtn;
    position: relative;
    text-decoration: none;
    color: #5c5c5c;
    margin-bottom: 12px;
    display: inline-block;
    margin-right: 4px;

    @include hover {
      color: black;

      &:before {
        color: #5c5c5c;
      }
    }

    &:before {
      content: ' / ';
    }
  }
</style>
